import { ContextTokenSchema, JWTSchema } from '@org-avp/context-token';
import { ThingNameSchema } from '@org-avp/device-models';
import { decodeJwt } from 'jose';
import { z } from 'zod';
export const PairingTokenSchema = ContextTokenSchema.omit({ exp: true }).extend({
    thingName: ThingNameSchema,
});
export const PairingRequestTokenSchema = JWTSchema.extend({
    pairingCode: z.string(),
    exp: z.coerce.number(),
    serialNumber: z.string().optional(),
});
export const decodePairingRequestToken = (token) => {
    const decodedToken = decodeJwt(token);
    return PairingRequestTokenSchema.parse(decodedToken);
};
export const decodePairingToken = (token) => {
    const decodedToken = decodeJwt(token);
    return PairingTokenSchema.parse(decodedToken);
};
//# sourceMappingURL=pairing.js.map